import { Layer, Source } from 'react-map-gl'

interface MapLayerPerimeterProps {
  polygonGeoJSON: {
    type: string
    features: {
      type: string
      geometry: {
        type: string
        coordinates: number[][][]
      }
    }[]
  }
}

export function MapLayerPerimeter({ polygonGeoJSON }: MapLayerPerimeterProps) {
  return (
    <Source id="polygon-source" type="geojson" data={polygonGeoJSON}>
      <Layer
        id="perimeter-fill"
        type="fill"
        paint={{
          'fill-color': '#6EBC0A',
          'fill-opacity': 0.3,
        }}
      />
      <Layer
        id="perimeter-border"
        type="line"
        paint={{
          'line-color': '#6EBC0A',
          'line-width': 2,
        }}
      />
    </Source>
  )
}
